module.exports = __webpack_public_path__ + "static/img/greedy_btn.9f63891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/greedy_btn.png
// module id = QvgH
// module chunks = 1